import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog.html',
})
export class DialogOverviewExampleDialog {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
@Component({
  selector: 'app-content',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
  public searchValue: string = null;

  public cities: Array<any> = [
	{
		"id": "84",
		"code": "CLA0084",
		"name": "Clamart",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.7957397",
		"longitude": "2.2167841",
		"codePostal": "92140",
		"logoUrl": "https://cla0184.epweb.pro/images/logos/CLA0184.jpg",
		"paymentUrl": "https://www.stationnement.gouv.fr/fps",
		"rapoUrl": "https://stationnement.clamart.fr/stationnement/rapo/new",
		"rapoAdress": "Gestion des RAPO",
		"rapoCP": "92140",
		"rapoVille": "Clamart",
		"Siret": "21920023500014",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	  {
		"id": "9",
		"code": "VIR0009",
		"name": "Viroflay",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.8017506",
		"longitude": "2.154987",
		"codePostal": "78220",
		"logoUrl": "https://vir0009.epweb.pro/images/logos/VIR0009.jpg",
		"paymentUrl": "",
		"rapoUrl": "https://voirie.q-park.fr/viroflay/stationnement/rapo/new",
		"rapoAdress": "Mairie de Viroflay",
		"rapoCP": "78221",
		"rapoVille": "Viroflay Cedex",
		"Siret": "21780686800014",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "10",
		"code": "MEL0010",
		"name": "Melun (FPS)",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.5421321",
		"longitude": "2.6202101",
		"codePostal": "77000",
		"logoUrl": "https://mel0010.epweb.pro/images/logos/MEL0010.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Police Municipale - Hotel de Ville - 16 rue Paul Doumer",
		"rapoCP": "77000",
		"rapoVille": "Melun",
		"Siret": "21770288500013",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "11",
		"code": "COM0011",
		"name": "Compiègne",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "49.4005793",
		"longitude": "2.7848179",
		"codePostal": "60200",
		"logoUrl": "https://com0011.epweb.pro/images/logos/COM0011.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Police Municipale Ville de Compiegne BP 30009",
		"rapoCP": "60321",
		"rapoVille": "Compiegne Cedex",
		"Siret": "21600158600017",
		"fps.cycle": "Partiel",
		"fps.min": "Non"
	},
	{
		"id": "12",
		"code": "VSM0012",
		"name": "Villiers-sur-Marne",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.8277991",
		"longitude": "2.5132042",
		"codePostal": "94350",
		"logoUrl": "https://vsm0012.epweb.pro/images/logos/VSM0012.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Mairie - Place de l'Hotel de Ville",
		"rapoCP": "94350",
		"rapoVille": "Villiers-sur-Marne",
		"Siret": "21940079300010",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "16",
		"code": "CHN0016",
		"name": "Cachan",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.7913847",
		"longitude": "2.3144249",
		"codePostal": "94230",
		"logoUrl": "https://chn0016.epweb.pro/images/logos/CHN0016.jpg",
		"paymentUrl": "",
		"rapoUrl": "https://cachan.e-habitants.com/stationnement/rapo/new",
		"rapoAdress": "Police Municipale - Hotel de ville- square de la libération",
		"rapoCP": "94239",
		"rapoVille": "Cachan",
		"Siret": "21940016500011",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "18",
		"code": "GRD0018",
		"name": "Guérande",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "47.3232512",
		"longitude": "-2.3802119",
		"codePostal": "44350",
		"logoUrl": "https://grd0018.epweb.pro/images/logos/GRD0018.jpg",
		"paymentUrl": "https://guerande.e-habitants.com/fps/",
		"rapoUrl": "",
		"rapoAdress": "Ville de Guérande - 7 place du marché au bois",
		"rapoCP": "44350",
		"rapoVille": "Guérande",
		"Siret": "21440069900143",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "29",
		"code": "DIE0029",
		"name": "Saint-Dié",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.887025",
		"longitude": "2.270015",
		"codePostal": "52100",
		"logoUrl": "https://die0029.epweb.pro/images/logos/DIE0029.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Police Municipale - Place de l'Europe",
		"rapoCP": "88100",
		"rapoVille": "Saint-Die-des-Vosges",
		"Siret": "21880413600016",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "30",
		"code": "RBX0030",
		"name": "Roubaix",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "50.6887078",
		"longitude": "3.1492011",
		"codePostal": "59100",
		"logoUrl": "https://rbx0030.epweb.pro/images/RBX0030/ROU0072.png",
		"paymentUrl": "https://www.jestationnearoubaix.com/fps/",
		"rapoUrl": "https://www.jestationnearoubaix.com/stationnement/rapo/new",
		"rapoAdress": "Parcogest - 5 rue du curoir",
		"rapoCP": "59100",
		"rapoVille": "Roubaix",
		"Siret": "21590512600011",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "38",
		"code": "VER0038",
		"name": "Versailles",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.8038627",
		"longitude": "2.0841591",
		"codePostal": "78000",
		"logoUrl": "https://ver0038.epweb.pro/images/logos/VER0038.jpg",
		"paymentUrl": "https://stationnement.versailles.fr/fps/",
		"rapoUrl": "https://stationnement.versailles.fr/stationnement/rapo/new",
		"rapoAdress": "Direction de la securite - 4 avenue de Paris - RP 1144",
		"rapoCP": "78011",
		"rapoVille": "Versailles Cedex",
		"Siret": "21780646200016",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "40",
		"code": "DIJ0040",
		"name": "Dijon",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "47.331881",
		"longitude": "5.032221",
		"codePostal": "21000",
		"logoUrl": "https://dij0040.epweb.pro/images/DIJ0040/DIJ0040.png",
		"paymentUrl": "https://www.jemegare.fr/dijon/fps/",
		"rapoUrl": "https://www.jemegare.fr/dijon/stationnement/rapo/new",
		"rapoAdress": "DiviaPark - BP 50929",
		"rapoCP": "21009",
		"rapoVille": "Dijon Cedex",
		"Siret": "24210041000123",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
  {
    "id": "46",
    "code": "VAL0046",
    "name": "Valenciennes",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "50.3621071",
    "longitude": "3.5141815",
    "codePostal": "59300",
    "logoUrl": "https://val0046.epweb.pro/images/logos/VAL0046.jpg",
    "paymentUrl": "",
    "rapoUrl": "",
    "rapoAdress": "SAEMVS - 6 rue Delsaux",
    "rapoCP": "59300",
    "rapoVille": "Valenciennes",
    "Siret": "21590606600018",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
	{
		"id": "65",
		"code": "EVR0065",
		"name": "Evry",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.6298355",
		"longitude": "2.4417726",
		"codePostal": "91000",
		"logoUrl": "https://evr0065.epweb.pro/images/logos/EVR0065.jpg",
		"paymentUrl": "https://stationnement.evry.fr/fps/",
		"rapoUrl": "https://stationnement.evrycourcouronnes.fr/stationnement/rapo/new",
		"rapoAdress": "Police municipale - place des Droits de l'Homme et du Citoyen",
		"rapoCP": "91011",
		"rapoVille": "Evry Cedex",
		"Siret": "21910228200569",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "71",
		"code": "GAR0071",
		"name": "La Garenne Colombe",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.9071095",
		"longitude": "2.243691",
		"codePostal": "92250",
		"logoUrl": "https://gar0071.epweb.pro/images/logos/GAR0071.jpg",
		"paymentUrl": "",
		"rapoUrl": "https://garenne-colombes.e-habitants.com/stationnement/rapo/new",
		"rapoAdress": "Police Municipale - 68 boulevard de la république",
		"rapoCP": "92250",
		"rapoVille": "La Garenne Colombes",
		"Siret": "21920035900012",
		"fps.cycle": "Partiel",
		"fps.min": "Oui"
	},
	{
		"id": "80",
		"code": "CLI0080",
		"name": "Clichy",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.5421321",
		"longitude": "2.6530403",
		"codePostal": "92110",
		"logoUrl": "https://cli0080.epweb.pro/images/logos/CLI0080.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Police Municipale - 96 rue Martre",
		"rapoCP": "92110",
		"rapoVille": "Clichy",
		"Siret": "21920024300018",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "83",
		"code": "ANG0083",
		"name": "Angoulème",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "45.645821",
		"longitude": "0.1450395",
		"codePostal": "16000",
		"logoUrl": "https://ang0083.epweb.pro/images/logos/ANG0083.jpg",
		"paymentUrl": "https://stationnement-angouleme.com/",
		"rapoUrl": "https://stationnement-angouleme.com/stationnement/rapo/new",
		"rapoAdress": "Police Municipale - 8 place Bouillaud",
		"rapoCP": "16000",
		"rapoVille": "Angoulème",
		"Siret": "21160015000018",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "93",
		"code": "VER0093",
		"name": "Vernon",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "49.097584",
		"longitude": "1.3566578",
		"codePostal": "27200",
		"logoUrl": "https://ver0093.epweb.pro/images/logos/VER0093.jpg",
		"paymentUrl": "",
		"rapoUrl": "https://jecontestemonfps.fr/vernon",
		"rapoAdress": "PARKOSERVICE - Unité Vernon - Pont de falaise",
		"rapoCP": "78124",
		"rapoVille": "Mareil-sur-Mauldre",
		"Siret": "21270681600015",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "100",
		"code": "STM0100",
		"name": "Saint-Malo",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.6462819",
		"longitude": "-2.0066529",
		"codePostal": "35400",
		"logoUrl": "https://stm0100.epweb.pro/images/logos/STM0100.jpg",
		"paymentUrl": "https://www.jemegare.fr/saint-malo/fps/",
		"rapoUrl": "https://jemegare.fr/saint-malo/stationnement/rapo/new",
		"rapoAdress": "Effia Stationnement",
		"rapoCP": "37206",
		"rapoVille": "Tours Cedex 03",
		"Siret": "21350288300019",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "109",
		"code": "LEN0109",
		"name": "Lens",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "50.4395206",
		"longitude": "2.7840507",
		"codePostal": "62300",
		"logoUrl": "https://len0109.epweb.pro/images/logos/LEN0109.jpg",
		"paymentUrl": "https://www.jemegare.fr/lens/fps/",
		"rapoUrl": "https://jemegare.fr/lens/stationnement/rapo/new",
		"rapoAdress": "Effia Stationnement - place Du G. de Gaulle",
		"rapoCP": "62300",
		"rapoVille": "Lens",
		"Siret": "21620498200013",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "117",
		"code": "BEZ0117",
		"name": "Beziers",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "43.3482155",
		"longitude": "3.1641805",
		"codePostal": "34500",
		"logoUrl": "https://bez0117.epweb.pro/images/logos/BEZ0117.jpg",
		"paymentUrl": "https://www.jemegare.fr/beziers/fps/",
		"rapoUrl": "https://jemegare.fr/beziers/stationnement/rapo/new",
		"rapoAdress": "Effia Stationnement - 50 cours de la République",
		"rapoCP": "69100",
		"rapoVille": "Villeurbanne",
		"Siret": "21340032800018",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "118",
		"code": "SCO0118",
		"name": "Sceaux",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.7760138",
		"longitude": "2.2875042",
		"codePostal": "92330",
		"logoUrl": "https://sco0118.epweb.pro/images/logos/SCO0118.jpg",
		"paymentUrl": "https://www.jemegare.fr/sceaux/fps",
		"rapoUrl": "https://jemegare.fr/sceaux/stationnement/rapo/new",
		"rapoAdress": "Effia Stationnement - DR IDF - 20 Rue Hector Malot",
		"rapoCP": "75012",
		"rapoVille": "Paris",
		"Siret": "21920071400018",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "123",
		"code": "BEB0123",
		"name": "Bourg-en-Bresse",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "",
		"longitude": "",
		"codePostal": "1000",
		"logoUrl": "https://beb0123.epweb.pro/images/logos/BEB0123.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Ville de Bourg en Bresse - Régie Bourg Parc Auto - place de l’Hôtel de Ville – BP 90 419",
		"rapoCP": "1012",
		"rapoVille": "Bourg-en-Bresse Cedex",
		"Siret": "21010053300012",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "124",
		"code": "BRI0124",
		"name": "Brive-la-gaillarde",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "45.1454606",
		"longitude": "1.4442878",
		"codePostal": "19312",
		"logoUrl": "https://bri0124.epweb.pro/images/logos/BRI0124.jpg",
		"paymentUrl": "",
		"rapoUrl": "https://brive.e-habitants.com/stationnement/rapo/new",
		"rapoAdress": "1 avenue Maillard",
		"rapoCP": "19100",
		"rapoVille": "Brive",
		"Siret": "21190310900018",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "125",
		"code": "CHA0125",
		"name": "Chambery",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "45.5822142",
		"longitude": " 5.871334",
		"codePostal": "73000",
		"logoUrl": "https://cha0125.epweb.pro/images/logos/CHA0125.jpg",
		"paymentUrl": "https://www.jemegare.fr/chambery/fps/",
		"rapoUrl": "https://jemegare.fr/chambery/stationnement/rapo/new",
		"rapoAdress": "EFFIA Stationnement Chambéry - 50 cours de la république",
		"rapoCP": "69100",
		"rapoVille": "Villeurbanne",
		"Siret": "21730065600014",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "136",
		"code": "PSG0136",
		"name": "Pré-Saint-Gervais",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.8840431",
		"longitude": "2.3966707",
		"codePostal": "93310",
		"logoUrl": "https://psg0136.epweb.pro/images/logos/PSG0136.jpg",
		"paymentUrl": "https://pre-saint-gervais.e-habitants.com/fps/",
		"rapoUrl": "https://pre-saint-gervais.e-habitants.com/stationnement/rapo/new",
		"rapoAdress": "Ville du Pre Saint-Gervais - 84 bis rue Andre Joineau",
		"rapoCP": "93311",
		"rapoVille": "LE PRE SAINT-GERVAIS",
		"Siret": "21930061300011",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "137",
		"code": "FIG0137",
		"name": "Figeac",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "44.6066671",
		"longitude": "1.9530543",
		"codePostal": "46100",
		"logoUrl": "https://fig0137.epweb.pro/images/logos/FIG0137.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Mairie de Figeac - 5 Rue de Colomb",
		"rapoCP": "46100",
		"rapoVille": "Figeac",
		"Siret": "21460102300010",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "138",
		"code": "HAG0138",
		"name": "Hagondange",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "49.2421572",
		"longitude": "6.0211413",
		"codePostal": "57300",
		"logoUrl": "https://hag0138.epweb.pro/images/logos/HAG0138.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Mairie de Hagondange - place Jean Burger",
		"rapoCP": "57300",
		"rapoVille": "Hagondange",
		"Siret": "21570283800016",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "139",
		"code": "BAD0139",
		"name": "Baden",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "47.6058872",
		"longitude": "-2.9736232",
		"codePostal": "56870",
		"logoUrl": "https://bad0139.epweb.pro/images/logos/BAD0139.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Police Municipale - 3 place Weilheim",
		"rapoCP": "56870",
		"rapoVille": "Baden",
		"Siret": "21560008100081",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "140",
		"code": "PTO0155",
		"name": "Puteaux",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.8823567",
		"longitude": "2.2208939",
		"codePostal": "92800",
		"logoUrl": "https://pto0155.epweb.pro/images/logos/PTO0155.jpg",
		"paymentUrl": "",
		"rapoUrl": "https://puteaux.e-habitants.com/stationnement/rapo/new",
		"rapoAdress": "Mairie de Puteaux – Contestation FPS - 131 rue de la république",
		"rapoCP": "92800",
		"rapoVille": "Puteaux",
		"Siret": "21920062300011",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "142",
		"code": "TLN0133",
		"name": "Toulon (fps)",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "43.1363397",
		"longitude": "5.8633912",
		"codePostal": "83000",
		"logoUrl": "https://tln0133.epweb.pro/images/logos/TLN0133.jpg",
		"paymentUrl": "",
		"rapoUrl": "https://toulon.e-habitants.com/stationnement/rapo/new",
		"rapoAdress": "Police Municipale - 1 place pasteur",
		"rapoCP": "83000",
		"rapoVille": "Toulon",
		"Siret": "21830137200015",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "143",
		"code": "MEG0143",
		"name": "Megeve",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "45.8396446",
		"longitude": "6.5541066",
		"codePostal": "74120",
		"logoUrl": "https://meg0143.epweb.pro/images/logos/MEG0143.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Mairie - Police Municipale - BP23",
		"rapoCP": "74120",
		"rapoVille": "Megeve",
		"Siret": "21740173600012",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "146",
		"code": "MAF0146",
		"name": "Maisons-Alfort",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "48.8017312",
		"longitude": "2.4049302",
		"codePostal": "94700",
		"logoUrl": "https://maf0146.epweb.pro/images/logos/MAF0146.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "Police Municipale - 119 avenue du General de Gaulle",
		"rapoCP": "94700",
		"rapoVille": "Maisons-Alfort",
		"Siret": "21940046200012",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "147",
		"code": "BDP0147",
		"name": "Baux-de-Provence",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "43.7491352",
		"longitude": "4.7700046",
		"codePostal": "13520",
		"logoUrl": "https://bdp0147.epweb.pro/images/logos/BDP0147.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "29 Rue du Château",
		"rapoCP": "13520",
		"rapoVille": "Les Baux-de-Provence",
		"Siret": "21130011600012",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "148",
		"code": "SMA0148",
		"name": "Saint-Maurice",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.8184337",
		"longitude": "2.4075251",
		"codePostal": "94410",
		"logoUrl": "https://sma0148.epweb.pro/images/logos/SMA0148.jpg",
		"paymentUrl": "https://www.jemegare.fr/saint-maurice/fps/",
		"rapoUrl": "https://jemegare.fr/saint-maurice/stationnement/rapo/new",
		"rapoAdress": "",
		"rapoCP": "",
		"rapoVille": "",
		"Siret": "21940069400010",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "149",
		"code": "VCN0149",
		"name": "Vincennes",
		"hasFps": "1",
		"hasRapo": "1",
		"hasFpsPaiement": "1",
		"hasFpsEhab": "1",
		"latitude": "48.8471232",
		"longitude": "2.420734",
		"codePostal": "94300",
		"logoUrl": "https://vcn0149.epweb.pro/images/logos/VCN0149.jpg",
		"paymentUrl": "https://www.jemegare.fr/vincennes/fps/",
		"rapoUrl": "https://jemegare.fr/vincennes/stationnement/rapo/new",
		"rapoAdress": "Effia Stationnement Vincennes RAPO - 20 rue Hector Malot",
		"rapoCP": "75012",
		"rapoVille": "Paris",
		"Siret": "21940080100011",
		"fps.cycle": "Complet",
		"fps.min": "Oui"
	},
	{
		"id": "151",
		"code": "BTM0151",
		"name": "Brantome",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "",
		"longitude": "",
		"codePostal": "24310",
		"logoUrl": "https://btm0151.epweb.pro/images/logos/BTM0151.jpg",
		"paymentUrl": "https://www.stationnement.gouv.fr/fps",
		"rapoUrl": "",
		"rapoAdress": "Mairie de Brantome en Perigord",
		"rapoCP": "24310",
		"rapoVille": "Brantome en Perigord",
		"Siret": "20005858400018",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "156",
		"code": "BDL0156",
		"name": "Bandol",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "43.1470287",
		"longitude": "5.7313174",
		"codePostal": "83150",
		"logoUrl": "https://bdl0156.epweb.pro/images/logos/BDL0156.jpg",
		"paymentUrl": "",
		"rapoUrl": "",
		"rapoAdress": "POLICE MUNICIPALE - BP 25",
		"rapoCP": "83150",
		"rapoVille": "Bandol",
		"Siret": "21830009300018",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
	{
		"id": "159",
		"code": "UZS159",
		"name": "Uzes",
		"hasFps": "1",
		"hasRapo": "",
		"hasFpsPaiement": "",
		"hasFpsEhab": "",
		"latitude": "44.0288821",
		"longitude": "4.3459937",
		"codePostal": "30700",
		"logoUrl": "https://uzs0159.epweb.pro/images/logos/UZS0159.jpg",
		"paymentUrl": "",
		"rapoUrl": "rapo@uzes.fr",
		"rapoAdress": "Service RAPO Mairie d’Uzès - 1 place Albert 1er BP 71103 ",
		"rapoCP": "30701",
		"rapoVille": "Uzes",
		"Siret": "21300334600011",
		"fps.cycle": "Complet",
		"fps.min": "Non"
	},
  {
    "id": "208",
    "code": "COR0208",
    "name": "Cormeilles-en-Parisis",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "48.9700592",
    "longitude": "2.1660587",
    "codePostal": "95240",
    "logoUrl": "https://cor0208.epweb.pro/images/logos/COR0208.jpg",
    "paymentUrl": "",
    "rapoUrl": "https://www.jecontestemonfps.fr/cormeilles/stationnement/rapo/new",
    "rapoAdress": "POLICE MUNICIPALE, 3 avenue Maurice Berteaux",
    "rapoCP": "95240",
    "rapoVille": "Cormeilles-en-Parisis",
    "Siret": "21950176400019",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
  {
    "id": "245",
    "code": "CAH0245",
    "name": "Cahors",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "44.4565006",
    "longitude": "1.3689732",
    "codePostal": "46000",
    "logoUrl": "https://cahors-flowbird.xtscloud.net/images/logos/CAH0245.jpg",
    "paymentUrl": "https://www.stationnement.gouv.fr/fps",
    "rapoUrl": "https://www.jecontestemonfps.fr/cahors/stationnement/rapo/new",
    "rapoAdress": "Mairie de Cahors, 72 Rue du Président Wilson",
    "rapoCP": "46000",
    "rapoVille": "Cahors",
    "Siret": "21460042100017",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
  {
    "id": "246",
    "code": "CHE0188",
    "name": "Le Chesnay",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "48.8254322",
    "longitude": "2.1130183",
    "codePostal": "78155",
    "logoUrl": "https://CHE0188.epweb.pro/images/logos/CHE0188.jpg",
    "paymentUrl": "",
    "rapoUrl": "https://jecontestemonfps.fr/lechesnay-rocquencourt/stationnement/rapo/new",
    "rapoAdress": "Mairie du Chesnay-Roquencourt, 9 Rue Pottier",
    "rapoCP": "78155",
    "rapoVille": "LE CHESNAY-ROCQUENCOURT",
    "Siret": "21920046600015",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
  {
    "id": "247",
    "code": "CCN0293",
    "name": "Carcans",
    "hasFps": "0",
    "hasRapo": "1",
    "hasFpsPaiement": "0",
    "hasFpsEhab": "0",
    "latitude": "",
    "longitude": "",
    "codePostal": "33121",
    "logoUrl": "https://carcans.xtscloud.net/images/logos/CCN0293.jpg",
    "paymentUrl": "",
    "rapoUrl": "https://jecontestemonfps.fr/carcans/stationnement/rapo/new",
    "rapoAdress": "Réclamation Stationnement Payant CARCANS - TPV - CS 61984",
    "rapoCP": "33050 ",
    "rapoVille": "BORDEAUX Cedex",
    "Siret": "21330097300129",
    "fps.cycle": "",
    "fps.min": ""
  },
  {
    "id": "248",
    "code": "CER0292",
    "name": "Ceret",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "42.4730888",
    "longitude": "2.7214581",
    "codePostal": "66400",
    "logoUrl": "https://ceret.xtscloud.net/images/logos/CER0292.jpg",
    "paymentUrl": "",
    "rapoUrl": "https://jecontestemonfps.fr/ceret",
    "rapoAdress": "6 boulevard Maréchal Joffre - 66400 CERET",
    "rapoCP": "66400",
    "rapoVille": "Céret",
    "Siret": "21660049400019",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
  {
    "id": "249",
    "code": "RAM0298",
    "name": "Ramatuelle",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "43.2115749",
    "longitude": "6.6099523",
    "codePostal": "83350",
    "logoUrl": "https://ramatuelle.xtscloud.net/images/logos/RAM0298.jpg",
    "paymentUrl": "",
    "rapoUrl": "https://jecontestemonfps.fr/ramatuelle",
    "rapoAdress": "60 BOULEVARD DU 8 MAI 1945",
    "rapoCP": "83350",
    "rapoVille": "Ramatuelle",
    "Siret": "21830101800014",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
  {
    "id": "250",
    "code": "FGR0305",
    "name": "Fougères",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "44.4565006",
    "longitude": "1.3689732",
    "codePostal": "35300",
    "logoUrl": "https://fougeres.xtscloud.net/images/logos/FGR0305.jpg",
    "paymentUrl": "https://www.stationnement.gouv.fr/fps",
    "rapoUrl": "https://www.jecontestemonfps.fr/fougeres",
    "rapoAdress": "Mairie de Fougères, 2 Rue Porte Saint-Léonard",
    "rapoCP": "35300",
    "rapoVille": "Fougères",
    "Siret": "21350115800017",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
  {
    "id": "251",
    "code": "TRS0329",
    "name": "Tours",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "44.4565006",
    "longitude": "1.3689732",
    "codePostal": "37000",
    "logoUrl": "https://tours.xtscloud.net/images/logos/TRS0237.jpg",
    "paymentUrl": "",
    "rapoUrl": "https://jecontestemonfps.fr/tours",
    "rapoAdress": "Réclamation Stationnement Payant Tours",
    "rapoCP": "CS 82064 - 33071",
    "rapoVille": "BORDEAUX Cedex",
    "Siret": "21370261600011",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
  {
    "id": "252",
    "code": "STD0326",
    "name": "Saint-Denis",
    "hasFps": "1",
    "hasRapo": "1",
    "hasFpsPaiement": "",
    "hasFpsEhab": "",
    "latitude": "48.9268252",
    "longitude": "2.3451031",
    "codePostal": "93200",
    "logoUrl": "https://saint-denis-flowbird.xtscloud.net/images/logos/STD0326.jpg",
    "paymentUrl": "",
    "rapoUrl": "https://www.jecontestemonfps.fr/saint-denis",
    "rapoAdress": "La Plaine Cedex",
    "rapoCP": "93214",
    "rapoVille": "Saint-Denis",
    "Siret": "21930066200018",
    "fps.cycle": "Complet",
    "fps.min": "Non"
  },
    {
      "id": "253",
      "code": "HOS0333",
      "name": "Hossegor",
      "hasFps": "0",
      "hasRapo": "1",
      "hasFpsPaiement": "0",
      "hasFpsEhab": "0",
      "latitude": "43.6679699",
      "longitude": "-1.4290036",
      "codePostal": "40150",
      "logoUrl": "https://hossegor.xtscloud.net/images/logos/HOS0333.jpg",
      "paymentUrl": "",
      "rapoUrl": "https://jecontestemonfps.fr/hossegor",
      "rapoAdress": "TPV CS 82064 - 33071 BORDEAUX Cedex",
      "Siret": "21400304800011",
      "fps.cycle": "Complet",
      "fps.min": "Non"
    },
    {
      "id": "254",
      "code": "TVL0334",
      "name": "Thionville",
      "hasFps": "0",
      "hasRapo": "1",
      "hasFpsPaiement": "0",
      "hasFpsEhab": "0",
      "latitude": "49.366669",
      "longitude": "6.16667",
      "codePostal": "57100",
      "logoUrl": "https://thionville.xtscloud.net/images/logos/TVL0334.jpg",
      "paymentUrl": "",
      "rapoUrl": "https://jecontestemonfps.fr/thionville",
      "rapoAdress": "TPV CS 82064 - 33071 BORDEAUX Cedex",
      "Siret": "21570672200018",
      "fps.cycle": "Complet",
      "fps.min": "Non"
    },
    {
      "id": "255",
      "code": "PDB0337",
      "name": "pays-de-belves",
      "hasFps": "0",
      "hasRapo": "1",
      "hasFpsPaiement": "0",
      "hasFpsEhab": "0",
      "latitude": "44.7758",
      "longitude": "1.0075",
      "codePostal": "24170",
      "logoUrl": "https://pays-de-belves.xtscloud.net/images/logos/PDB0337.jpg",
      "paymentUrl": "",
      "rapoUrl": "https://jecontestemonfps.fr/pays-de-belves",
      "rapoAdress": "policemunicipalebelves@gmail.com",
      "Siret": "20005973100014",
      "fps.cycle": "Complet",
      "fps.min": "Non"
    },
    {
      "id": "256",
      "code": "URU0336",
      "name": "Urrugne",
      "hasFps": "0",
      "hasRapo": "1",
      "hasFpsPaiement": "0",
      "hasFpsEhab": "0",
      "latitude": "43.3583",
      "longitude": "-1.7",
      "codePostal": "64122",
      "logoUrl": "https://urrugne.xtscloud.net/images/logos/URU0336.jpg",
      "paymentUrl": "",
      "rapoUrl": "https://jecontestemonfps.fr/urrugne",
      "rapoAdress": "Mairie d'Urrugne",
      "Siret": "21640545600015",
      "fps.cycle": "Complet",
      "fps.min": "Non"
    },
    {
      "id": "257",
      "code": "ARL0324",
      "name": "Arles",
      "hasFps": "0",
      "hasRapo": "1",
      "hasFpsPaiement": "0",
      "hasFpsEhab": "0",
      "latitude": "43.3583",
      "longitude": "-1.7",
      "codePostal": "64122",
      "logoUrl": "https://arles.xtscloud.net/images/logos/ARL0324.jpg",
      "paymentUrl": "",
      "rapoUrl": "https://jecontestemonfps.fr/arles",
      "rapoAdress": "7 bis boulevard des Lices",
      "rapoCP": "13200",
      "rapoVille": "Arles",
      "Siret": "21130004100012",
      "fps.cycle": "Complet",
      "fps.min": "Non"
    }
];

   constructor(public dialog: MatDialog) {}

  ngOnInit() { }

  filterCities() {

    console.log(this.cities.filter(city => city == this.searchValue), this.searchValue);
    // Si searchValue est vide, je renvois toutes les cities.
    if ( !this.searchValue ) {
      return this.cities;
    } else {
      return this.cities.filter(city => city.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1 || city.codePostal.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1);
    }

  }

  openFpsPaymentPage(city) {
	  let dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '550px',
      data: {'city':city}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
	  if (!city.rapoUrl || city.rapoUrl.length==0){
		  //document.location.href = "https://www.stationnement.gouv.fr/fps";
	  }
	  else{
		  //document.location.href = city.rapoUrl;
	  }
  }
}



// WEBPACK FOOTER //
// ./src/app/root/root.component.ts